import { Link, Route, Switch, useRouteMatch } from "react-router-dom";
import { Task } from "../../store/viewmodels/TaskViewModel";
import StudentTask from "./StudentTask";
import { useAppSelector } from '../../store/Hooks';
import { isTaskDone } from "../../utils/TaskNavigationServices";


function StudentTasks() {
    let { path } = useRouteMatch();
    const studentData = useAppSelector(state => state.studentData);
    const tasks: Task[] = studentData.student.task_access_list;

    return (
        <Switch>
            <Route exact path={path}>
                <h1 className="text-3xl font-bold leading-tight text-gray-900">Tehtävät</h1>
                <StudentTaskList tasks={tasks} />
            </Route>
            <Route path={`${path}/:taskId`}>
                <StudentTask />
            </Route>
        </Switch>
    );
}

interface StudentTaskListProps {
    tasks: Task[]
}

function StudentTaskList(props: StudentTaskListProps) {
    if (!props.tasks) { return <div></div> }

    let tasklist = [] as any;

    for (let i: number = 0; i < props.tasks.length; i++) {
        tasklist.push(<StudentTaskListItem task={props.tasks[i]} />);
    }

    return (
        <div>
            <ul className="mt-3 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
                {tasklist}
            </ul>
        </div>
    )
}

interface StudentTaskListItemProps {
    task: Task
}

function StudentTaskListItem(props: StudentTaskListItemProps) {
    let { path } = useRouteMatch();
    const studentData = useAppSelector(state => state.studentData);
    const student = studentData.student;

    if (props.task.one_time_only) {
        let isDone: boolean = isTaskDone(props.task, student);
        if (isDone) return (<></>);
    }

    return (
        <Link key={props.task.id} to={`${path}/${props.task.id}`}>
            <li key={props.task.name} className="col-span-1 flex shadow-sm rounded-md">
                <div className='bg-teal-500 bgflex-shrink-0 flex items-center justify-center w-16 text-white text-sm font-medium rounded-l-md'>
                    {props.task.id}
                </div>
                <div className="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
                    <div className="flex-1 px-4 py-2 text-sm truncate">
                        <span className="text-gray-900 font-medium hover:text-gray-600">
                            {props.task.name}
                        </span>
                        <p className="text-gray-500">{props.task.type}</p>
                    </div>
                </div>
            </li>
        </Link>
    );

}

export default StudentTasks;